function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
export const buildOptionsFromArray = (array, key, value) => {
  return array.map((record, idx) => ({
    key: idx,
    text: toTitleCase(record[key]),
    value: record[value],
  }));
};

export const buildOptionsFromStrings = array => {
  return array.map((record, idx) => ({
    key: idx,
    text: record,
    value: record,
  }));
};

export const buildOptionsFromDict = dict =>
  Object.entries(dict).map(item => ({
    key: item[0],
    value: item[1],
    text: item[0],
  }));
